<template>
  <teleport to="#modalTeleport">
    <ConfirmModal ref="confirmModal"></ConfirmModal>
  </teleport>
  <HeadlineComponent :subtitle="`Insgesamt: ${ticketTemplates.length}`">Ticket Templates</HeadlineComponent>
  <RouterLink :to="`/events/${event.id}/ticketTemplates/create`" class="btn btn-sm btn-primary mb-3" v-if="isAdmin">Neues
    Template</RouterLink>
  <template v-for="ticketTemplate of ticketTemplates" :key="ticketTemplate.id">
    <div class="template mb-4">
      <div>
        <div class="img mr-3">
          Voucher <br/>
          <a :href="`/api/event/${event.id}/tickettemplate/${ticketTemplate.id}/pdf`" target="_blank" rel="noopener"><img
              :src="`/api/event/${event.id}/tickettemplate/${ticketTemplate.id}/png`" alt="Voucher"></a>
        </div>
        <div class="img" v-if="ticketTemplate.has_badge">
          Badge<br />
          <a :href="`/api/event/${event.id}/tickettemplate/${ticketTemplate.id}/pdf?type=badge`" target="_blank"
            rel="noopener"><img :src="`/api/event/${event.id}/tickettemplate/${ticketTemplate.id}/png?type=badge`" alt="Badge"></a>
        </div>
      </div>
      <div class="info">
        <div>{{ ticketTemplate.name }}</div>
        <div class="text-black-50" v-if="event.crew_template === ticketTemplate.id"><span class="fa fa-ticket"></span>
          Crew Ticket Template</div>
      </div>
      <div class="system-info">
        <RouterLink :to="`/events/${event.id}/ticketTemplates/create/${ticketTemplate.id}`"
          class="btn btn-secondary btn-sm mt-2" v-if="isAdmin">Kopieren <span class="fa fa-copy"></span></RouterLink>
        <RouterLink :to="`/events/${event.id}/ticketTemplates/${ticketTemplate.id}`" class="btn btn-primary btn-sm mt-2"
          v-if="isAdmin">Bearbeiten <span class="fa fa-pencil"></span></RouterLink>
        <LoadingButton @click="remove(ticketTemplate);" class="btn btn-danger btn-sm mt-2" v-if="isAdmin"
          :loading="ticketTemplate.loading">Löschen <span class="fa fa-remove"></span></LoadingButton>
      </div>
    </div>
    <hr class="mb-4 volunteer-hr" />
  </template>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import { useUserStore } from "@/stores/user.js";
import ticketService from "@/services/ticket.service.js";
import eventService from "@/services/event.service.js";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import LoadingButton from "@/components/LoadingButton.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import * as Sentry from '@sentry/vue';

export default {
  name: "TicketTemplatesView",
  components: { HeadlineComponent, LoadingButton, ConfirmModal },
  data() {
    return {
      ticketTemplates: [],
      event: {}
    }
  },
  async beforeRouteEnter(to, from, next) {
    let ticketTemplates, event
    try {
      let response = await ticketService.getTicketTemplates(to.params.event);
      ticketTemplates = response.data;
    } catch (e) {
      if (e) {
        Sentry.captureException(e);
        useAlertsStore().add('danger', "Es ist was unerwartetes schief gegangen..");
        window.scrollTo(0, 0);
        next()
        return
      }
    }
    try {
      let response = await eventService.get(to.params.event);
      event = response.data;
    } catch (e) {
      if (e) {
        Sentry.captureException(e);
        useAlertsStore().add('danger', "Es ist was unerwartetes schief gegangen..");
        window.scrollTo(0, 0);
        next()
        return
      }
    }
    next(vm => {
      vm.ticketTemplates = ticketTemplates;
      vm.event = event;
    })
  },
  computed: {
    ...mapState(useUserStore, ['isAdmin'])
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: 'add' }),
    async remove(ticketTemplate) {
      ticketTemplate.loading = true
      if (await this.$refs.confirmModal.show('Ticket Template löschen', `Soll das Ticket Template ${ticketTemplate.name} wirklich gelöscht werden?`)) {
        try {
          let response = await ticketService.deleteTicketTemplate(this.$route.params.event, ticketTemplate.id);
          for (let i = 0; i < this.ticketTemplates.length; i++) {
            if (this.ticketTemplates[i].id === ticketTemplate.id) {
              this.ticketTemplates.splice(i, 1);
            }
          }
          this.addAlert('success', response.data);
        } catch (e) {
          if (e) {
            Sentry.captureException(e);
            this.addAlert('danger', "Es ist was unerwartetes schief gegangen..");
            window.scrollTo(0, 0);
          }
        }
      }
      ticketTemplate.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
.template {
  justify-content: space-between;
  align-items: center;
  display: flex;
}

.img {
  display: inline-block;
  vertical-align: middle;
  text-align: center;

  img {
    max-height: 100px;
    width: auto;
  }
}

.info,
.system-info {
  vertical-align: middle;
  display: inline-block;
  margin-left: 10px;
}

.system-info {
  text-align: right;
}
</style>